import { useParams } from 'react-router-dom'

import type { ReactElement } from 'react'

import ImagePreview from '~/components/ImagePreview'
import VideoPreview from '~/components/VideoPreview'
import { useFileDetailsQuery } from '~/queries/files'
import { getFileType } from '~/utils/file'

import './styles.scss'

const FileFullScreen = (): ReactElement => {
  const { fileId } = useParams<{ fileId: string }>()

  const { data: fileDetails } = useFileDetailsQuery(fileId)

  return (
    <div className="file-full-screen-view">
      {fileDetails ? (
        getFileType(fileDetails.mime_type) === 'video' ? (
          <VideoPreview url={fileDetails?.download_url} />
        ) : (
          <ImagePreview src={fileDetails?.download_url} />
        )
      ) : null}
    </div>
  )
}

export default FileFullScreen
